import * as React from "react";
import type { SVGProps } from "react";
const SvgCustomerExperiencePersonalization = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={64}
    height={64}
    fill="none"
    {...props}
  >
    <path
      fill="#D3ECF8"
      d="M39.457 23.612a8.388 8.388 0 1 1-16.775 0 8.388 8.388 0 0 1 16.775 0Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="M31.07 30.25a6.638 6.638 0 1 0 0-13.276 6.638 6.638 0 0 0 0 13.275Zm0 1.75a8.388 8.388 0 1 0 0-16.776 8.388 8.388 0 0 0 0 16.775Z"
      clipRule="evenodd"
    />
    <path
      fill="#D3ECF8"
      d="M42.832 48.776H21.274c-1.12 0-2.125-.76-2.25-1.873-.98-8.772 8.261-11.126 13.327-11.174 10.91.638 13.025 6.929 12.657 11.228-.093 1.091-1.08 1.82-2.176 1.82Z"
    />
    <path
      fill="#26A3DD"
      fillRule="evenodd"
      d="m32.372 34.853.03.002c5.618.329 9.131 2.127 11.175 4.551 2.035 2.413 2.501 5.311 2.303 7.625-.14 1.643-1.605 2.62-3.048 2.62H21.274c-1.486 0-2.937-1.02-3.12-2.651-.263-2.357.158-4.334 1.062-5.962.899-1.62 2.245-2.84 3.755-3.744 2.997-1.797 6.743-2.415 9.372-2.44h.03Zm-11.626 7.035c-.712 1.282-1.079 2.889-.852 4.918.066.595.626 1.095 1.38 1.095h21.558c.747 0 1.258-.479 1.305-1.019.17-1.985-.239-4.381-1.897-6.348-1.646-1.952-4.638-3.616-9.91-3.93-2.435.028-5.826.612-8.46 2.19-1.311.787-2.408 1.803-3.124 3.094ZM6.32 2.546a3.75 3.75 0 0 0-3.75 3.75v10.59a1.25 1.25 0 1 1-2.5 0V6.296A6.25 6.25 0 0 1 6.32.046h11.47a1.25 1.25 0 1 1 0 2.5H6.32ZM57.694 2.546a3.75 3.75 0 0 1 3.75 3.75v10.59a1.25 1.25 0 0 0 2.5 0V6.296a6.25 6.25 0 0 0-6.25-6.25h-11.47a1.25 1.25 0 0 0 0 2.5h11.47ZM2.57 57.69a3.75 3.75 0 0 0 3.75 3.75h8.039a1.25 1.25 0 1 1 0 2.5H6.32a6.25 6.25 0 0 1-6.25-6.25V42.998a1.25 1.25 0 1 1 2.5 0V57.69ZM61.444 57.69a3.75 3.75 0 0 1-3.75 3.75h-8.038a1.25 1.25 0 0 0 0 2.5h8.038a6.25 6.25 0 0 0 6.25-6.25V42.998a1.25 1.25 0 0 0-2.5 0V57.69Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCustomerExperiencePersonalization;
